import { del, get, put } from '@aiptyg/api-client';
import type {
  WithdrawalAccountDTO,
  WithdrawalAccountListParams,
  WithdrawalAccountListResponseDTO,
  WithdrawalAccountPayload,
  WithdrawalAccountStatusPayload,
} from './types';

export function listWithdrawalAccounts(params: WithdrawalAccountListParams): Promise<WithdrawalAccountListResponseDTO> {
  const qs = new URLSearchParams();
  if (params.marketId) qs.set('market_id', params.marketId);
  qs.set('page', String(params.page));
  qs.set('page_size', String(params.pageSize));
  if (params.userId.trim()) qs.set('user_id', params.userId.trim());
  if (params.keyword.trim()) qs.set('keyword', params.keyword.trim());
  if (params.accountKeyword.trim()) qs.set('account_keyword', params.accountKeyword.trim());
  if (params.nameKeyword.trim()) qs.set('name_keyword', params.nameKeyword.trim());
  if (params.status.trim()) qs.set('status', params.status.trim());
  return get<WithdrawalAccountListResponseDTO>(`/v1/admin/withdrawal-accounts?${qs.toString()}`);
}

export function updateWithdrawalAccount(
  accountId: number,
  payload: WithdrawalAccountPayload,
): Promise<WithdrawalAccountDTO> {
  return put<WithdrawalAccountDTO>(`/v1/admin/withdrawal-accounts/${accountId}`, { ...payload });
}

export function upsertUserAlipayWithdrawalAccount(
  userId: number,
  payload: WithdrawalAccountPayload,
): Promise<WithdrawalAccountDTO> {
  return put<WithdrawalAccountDTO>(`/v1/admin/users/${userId}/withdrawal-accounts/alipay`, { ...payload });
}

export function updateWithdrawalAccountStatus(
  accountId: number,
  payload: WithdrawalAccountStatusPayload,
): Promise<WithdrawalAccountDTO> {
  return put<WithdrawalAccountDTO>(`/v1/admin/withdrawal-accounts/${accountId}/status`, { ...payload });
}

export function deleteWithdrawalAccount(accountId: number): Promise<{ message: string }> {
  return del<{ message: string }>(`/v1/admin/withdrawal-accounts/${accountId}`);
}
